export const getUserAddress = (settlement?: string, street?: string, number?: string, corpus?: string) => {
  return ` ${settlement ? `${settlement}` : ''} ${street ? `${street}` : ''} ${number ?? ''} ${
    corpus ? `к.${corpus}` : ''
  }`;
};
